export const LogoEdubookLandscapeGradient = () => (
  <svg
    fill='none'
    height='325'
    viewBox='0 0 1024 325'
    width='1024'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>edubookLandscapeGradient</title>
    <path
      clipRule='evenodd'
      d='M737.824 324.95L738.013 324.994L738.04 324.9L954.581 274.937L945.703 244.336L737.826 292.21L530.039 244.336L521.161 274.937L737.608 324.9L737.635 324.994L737.824 324.95Z'
      fill='url(#paint0_linear_3708_2)'
      fillRule='evenodd'
    />
    <path
      d='M37.8735 33.5289H128.354L123.16 6.89478H0V33.5289H37.8735Z'
      fill='url(#paint1_linear_3708_2)'
    />
    <path
      d='M101.437 108.331L95.9587 81.4138H37.8735H0V108.331H37.8735H101.437Z'
      fill='url(#paint2_linear_3708_2)'
    />
    <path
      d='M123.16 158.294H37.8735H0V184.645H128.638L123.16 158.294Z'
      fill='url(#paint3_linear_3708_2)'
    />
    <path
      d='M266.436 184.645H248.68L240.841 173.122C229.696 182.85 217.513 187.762 204.195 187.762C184.456 187.762 168.966 181.811 157.538 169.817C146.11 157.916 140.443 141.671 140.443 121.271C140.443 108.048 142.993 96.3364 148.188 86.2305C153.288 76.1247 160.749 68.2855 170.572 62.7131C180.3 57.1407 191.917 54.3072 205.329 54.3072C209.484 54.3072 213.924 55.0629 218.646 56.574C223.368 58.0852 227.902 60.0685 232.246 62.7131V2.83338L266.531 0V184.55L266.436 184.645ZM205.518 158.766C210.051 158.766 214.49 157.916 218.74 156.122C222.99 154.422 227.524 151.777 232.246 148.283V94.1641C227.713 90.2918 223.368 87.5528 219.213 85.9472C215.057 84.2472 210.523 83.4916 205.612 83.4916C196.356 83.4916 189.084 86.9861 183.606 94.0697C178.222 101.153 175.483 110.22 175.483 121.365C175.483 132.51 178.128 141.577 183.417 148.471C188.706 155.366 196.073 158.766 205.518 158.766Z'
      fill='url(#paint4_linear_3708_2)'
    />
    <path
      d='M349.078 160.561C355.028 160.561 360.6 159.238 365.795 156.499C370.99 153.76 376.751 150.172 383.079 145.638V57.8018H417.08V184.645H394.885L389.123 171.044C381.284 176.617 372.879 180.961 364.001 184.078C355.123 187.195 347.189 188.8 340.2 188.8C324.144 188.8 312.904 184.267 306.482 175.2C300.059 166.133 296.848 153.477 296.848 137.327V57.8018H330.849V135.721C330.849 143.56 332.455 149.699 335.666 154.044C338.878 158.388 343.411 160.561 349.172 160.561H349.078Z'
      fill='url(#paint5_linear_3708_2)'
    />
    <path
      d='M670.105 187.762C656.505 187.762 644.604 185.023 634.404 179.639C624.204 174.256 616.365 166.511 610.698 156.5C605.125 146.488 602.292 134.777 602.292 121.365C602.292 107.954 605.031 96.1476 610.698 86.0417C616.27 75.9358 624.204 68.0967 634.404 62.6187C644.604 57.1408 656.505 54.4019 670.105 54.4019C683.706 54.4019 695.606 57.1408 705.806 62.5243C716.007 67.9079 723.846 75.6525 729.513 85.664C735.085 95.6754 737.919 107.387 737.919 120.798C737.919 134.21 735.085 146.016 729.513 156.122C723.94 166.228 716.007 174.067 705.806 179.545C695.606 185.023 683.706 187.762 670.105 187.762ZM702.784 120.798C702.784 109.843 699.762 100.87 693.623 93.8808C687.484 86.8917 679.644 83.3972 670.105 83.3972C660.566 83.3972 652.916 86.9862 646.682 94.0698C640.449 101.248 637.426 110.315 637.426 121.271C637.426 132.227 640.449 141.199 646.588 148.188C652.727 155.177 660.566 158.672 670.105 158.672C679.644 158.672 687.295 155.083 693.528 147.905C699.667 140.727 702.784 131.66 702.784 120.704V120.798Z'
      fill='url(#paint6_linear_3708_2)'
    />
    <path
      d='M818.671 187.762C805.07 187.762 793.17 185.023 782.97 179.639C772.769 174.256 764.93 166.511 759.264 156.5C753.691 146.488 750.858 134.777 750.858 121.365C750.858 107.954 753.597 96.1476 759.264 86.0417C764.836 75.9358 772.769 68.0967 782.97 62.6187C793.17 57.1408 805.07 54.4019 818.671 54.4019C832.271 54.4019 844.172 57.1408 854.372 62.5243C864.572 67.9079 872.412 75.6525 878.078 85.664C883.651 95.6754 886.484 107.387 886.484 120.798C886.484 134.21 883.651 146.016 878.078 156.122C872.506 166.228 864.572 174.067 854.372 179.545C844.172 185.023 832.271 187.762 818.671 187.762ZM851.35 120.798C851.35 109.843 848.328 100.87 842.189 93.8808C836.049 86.8917 828.21 83.3972 818.671 83.3972C809.132 83.3972 801.482 86.9862 795.248 94.0698C789.015 101.248 785.992 110.315 785.992 121.271C785.992 132.227 789.014 141.199 795.154 148.188C801.293 155.177 809.132 158.672 818.671 158.672C828.21 158.672 835.86 155.083 842.094 147.905C848.233 140.727 851.35 131.66 851.35 120.704V120.798Z'
      fill='url(#paint7_linear_3708_2)'
    />
    <path
      d='M939.469 143.088V184.645H905.752V2.92793L939.469 0.0945435V104.176L993.871 54.2129L1012.95 78.2971L977.437 109.37L1024 184.645H984.993L953.07 130.999L939.469 142.994V143.088Z'
      fill='url(#paint8_linear_3708_2)'
    />
    <path
      d='M561.868 88.2141C574.619 78.2971 580.947 67.7189 580.947 56.5741C580.947 39.4791 575.847 26.9175 565.552 18.8895C555.257 10.8615 540.995 6.89478 522.673 6.89478H453.632V35.1345H517.667C526.734 35.1345 533.534 36.8345 538.162 40.1402C542.79 43.4459 545.057 49.1127 545.057 57.1408C545.057 64.5077 542.129 69.9857 536.179 73.7636C530.229 77.5415 522.295 79.4304 512.378 79.4304H453.537V106.915H526.262C534.762 106.915 541.562 109.181 546.568 113.715C551.574 118.248 554.029 124.576 554.029 132.793C554.029 140.444 551.29 146.394 545.907 150.549C540.523 154.705 533.156 156.783 523.9 156.783H453.537V184.739H526.451C545.623 184.739 560.829 180.111 572.163 170.761C583.497 161.411 589.164 148.66 589.164 132.415C589.164 112.581 580.002 97.8477 561.679 88.2141H561.868Z'
      fill='url(#paint9_linear_3708_2)'
    />
    <defs>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint0_linear_3708_2'
        x1='24.9337'
        x2='963.553'
        y1='-14.2614'
        y2='329.245'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint1_linear_3708_2'
        x1='18.1339'
        x2='956.752'
        y1='4.34468'
        y2='347.851'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint2_linear_3708_2'
        x1='-7.55581'
        x2='930.969'
        y1='74.5191'
        y2='418.026'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint3_linear_3708_2'
        x1='-30.6955'
        x2='907.924'
        y1='137.705'
        y2='481.211'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint4_linear_3708_2'
        x1='14.0727'
        x2='952.597'
        y1='15.5838'
        y2='359.089'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint5_linear_3708_2'
        x1='21.6285'
        x2='960.247'
        y1='-5.28909'
        y2='338.311'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint6_linear_3708_2'
        x1='57.5189'
        x2='996.044'
        y1='-103.137'
        y2='240.369'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint7_linear_3708_2'
        x1='74.9906'
        x2='1013.61'
        y1='-151.021'
        y2='192.485'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint8_linear_3708_2'
        x1='96.6189'
        x2='1035.14'
        y1='-209.957'
        y2='133.55'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='paint9_linear_3708_2'
        x1='45.146'
        x2='983.671'
        y1='-69.4188'
        y2='274.087'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
    </defs>
  </svg>
)
